import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import committees from "../../utils/committees.json";
import { useState } from "react";
import { Close } from "@mui/icons-material";
import ContentLayout from "../../components/ContentLayout";

type Props = {
  name: string;
  incharge: Array<string>;
};

const Committe = () => {
  const [data, setData] = useState<Props>();
  const [open, setOpen] = useState<boolean>(false);

  const handleClose = () => {
    setOpen(false);
    setData(undefined);
  };

  const midpoint = Math.ceil(committees.length / 2);

  const renderCommittees = (items: Props[]) => (
    <ul style={{ paddingLeft: 16 }}>
      {items?.map((committee: Props, i: number) => (
        <li key={i || committee?.name} style={{ paddingBottom: 15 }}>
          <Link
            sx={{ cursor: "pointer" }}
            onClick={() => {
              setData(committee);
              setOpen(true);
            }}
          >
            {committee?.name}
          </Link>
        </li>
      ))}
    </ul>
  );

  const groupByName = (str: string) => {
    let names = str.split(",").map((name) => name.trim());
    let groupedNames = [];
    for (let i = 0; i < names.length; i += 2) {
      let pair = names.slice(i, i + 2).join(", ");
      groupedNames.push(pair);
    }
    // let result = groupedNames.join('\n');
    return groupedNames;
  };

  function splitSectionsAndNames(entries: any[]) {
    return entries.map((entry) => {
      let [section, names] = entry.split(" - ");
      section = section.trim();
      names = names ? names.trim() : "";
      return {
        section: section,
        names: names,
      };
    });
  }

  return (
    <>
      <ContentLayout
        children={
          <Grid
            container
            sx={{ backgroundColor: "primary.light", p: { xs: 1, md: 3 } }}
            spacing={2}
          >
            <Grid item xs={12} md={6}>
              {renderCommittees(committees.slice(0, midpoint))}
            </Grid>
            <Grid item xs={12} md={6}>
              {renderCommittees(committees.slice(midpoint))}
            </Grid>
          </Grid>
        }
      />
      <Dialog
        maxWidth={"sm"}
        open={open}
        fullWidth
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ zIndex: 9999 }}
        scroll="paper"
      >
        <DialogTitle id="alert-dialog-title" sx={{ color: "InfoText" }}>
          {data?.name}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
        <DialogContent dividers>
          {data?.incharge.map((incharge, j) => (
            <Typography py={0.5} color={"GrayText"} display={"none"}>
              {incharge}
            </Typography>
          ))}
          {data && (
            <TableContainer component={Paper}>
              <Table>
                <TableHead
                  sx={{ backgroundColor: "primary.main", color: "white" }}
                >
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold", p: 1, px: 2 }}>
                      {" "}
                      {data?.name !== "Year Co-ordinators"
                        ? "Incharge"
                        : "Section"}
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", p: 1, px: 2 }}>
                      Members
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.name === "Year Co-ordinators" &&
                    splitSectionsAndNames(data?.incharge).map((items, i) => (
                      <TableRow key={i}>
                        <TableCell sx={{ color: "GrayText", p: 0.5, px: 2 }}>
                          <Typography>{items.section}</Typography>
                        </TableCell>
                        <TableCell sx={{ color: "GrayText", p: 0.5, px: 2 }}>
                          <Typography>{items.names}</Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  {data?.name !== "Year Co-ordinators" && (
                    <TableRow>
                      {
                        data?.incharge.map((incharge, i) => (
                          <TableCell key={i} sx={{ color: "GrayText" }}>
                            {incharge
                              .replace(/^INCHARGE\s*-\s*/, "")
                              .split(",")
                              .map((names, i) => (
                                <Typography key={i} noWrap>
                                  {names}
                                </Typography>
                              ))}
                          </TableCell>
                        ))[0]
                      }

                      {
                        data?.incharge.map((incharge, j) => (
                          <TableCell key={j} sx={{ color: "GrayText" }}>
                            {groupByName(
                              incharge.replace(/^MEMBERS\s*-\s*/, "")
                            ).map((names, i) => (
                              <Typography key={i}>{names}</Typography>
                            ))}
                          </TableCell>
                        ))[1]
                      }
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Committe;
